


import React from 'react';
import { NavLink } from 'react-router-dom';
import { assets } from '../assets/assets';

const Sidebar = () => {
  const linkStyle = ({ isActive }) =>
    `d-flex align-items-center gap-3 px-3 py-2 rounded text-decoration-none fw-medium transition-all ${
      isActive ? 'bg-white text-danger' : 'text-danger bg-transparent custom-hover'
    }`;

  return (
    <div
      className="sidebar d-flex flex-column min-vh-100 border-end py-3 px-2"
      style={{
        backgroundColor: '#d3d3d3',
        width: '80px',
        transition: 'width 0.3s',
      }}
    >
      <style>
        {`
          @media (min-width: 768px) {
            .sidebar {
              width: 240px !important;
            }
          }
          .transition-all {
            transition: all 0.3s ease-in-out;
          }
          .custom-hover:hover {
            background-color: #f8f9fa !important;
            color: white !important;
          }
        `}
      </style>

      <NavLink to="/add" className={({ isActive }) => linkStyle({ isActive })}>
        <img src={assets.add_icon} alt="Add" width="24" height="24" />
        <span className="d-none d-md-inline">Add Items</span>
      </NavLink>

      <NavLink to="/list" className={({ isActive }) => linkStyle({ isActive })}>
        <img src={assets.order_icon} alt="List" width="24" height="24" />
        <span className="d-none d-md-inline">List Items</span>
      </NavLink>

      <NavLink to="/orders" className={({ isActive }) => linkStyle({ isActive })}>
        <img src={assets.order_icon} alt="Orders" width="24" height="24" />
        <span className="d-none d-md-inline">Orders</span>
      </NavLink>
    </div>
  );
};

export default Sidebar;

